import { useLocation } from 'react-router';

export const useTrackerIdsFromUrl = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const trackerIdsParam = searchParams.get('trackerIds');
  return trackerIdsParam ? trackerIdsParam.split(',') : [];
};
